/* import __COLOCATED_TEMPLATE__ from './layout-inserter.hbs.js'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { IMAGE_PLACEHOLDER_CIRCLE, IMAGE_PLACEHOLDER_RECTANGULAR, LAYOUTS, PARAGRAPH_TEXT, PARAGRAPH_TEXT_SHORT, TITLE_TEXT } from '@intercom/composer-ember/components/tools/media-inserter/constants';
let LayoutInserter = (_class = class LayoutInserter extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "paragraphTextShort", PARAGRAPH_TEXT_SHORT);
    _defineProperty(this, "paragraphText", PARAGRAPH_TEXT);
    _defineProperty(this, "titleText", TITLE_TEXT);
    _defineProperty(this, "imagePlaceHolderRectangular", IMAGE_PLACEHOLDER_RECTANGULAR);
    _defineProperty(this, "imagePlaceholderCircle", IMAGE_PLACEHOLDER_CIRCLE);
  }
  insertBlockAndFocus(layoutName) {
    let pos = this.args.insertBlock(LAYOUTS[layoutName]);
    this.args.analytics.trackAnalyticsEvent('inserted', {
      block_type: 'table',
      layout_name: layoutName
    });
    if (pos !== null) {
      //Ensure the image is not selected otherwise the file picker would show after inserting the layout.
      let textNodes = this.args.commands.findTextNodes('table');
      let newPosition = pos + textNodes[0].pos;
      this.args.commands.setSelection(newPosition, newPosition);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "insertBlockAndFocus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertBlockAndFocus"), _class.prototype), _class);
export { LayoutInserter as default };